<template>
  <BaseCustomizeMetal componentCode="AT" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAT",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  img {
    // 因葫蘆的形狀是垂直的，以高 100% 為標準撐開
    width: auto !important;
    height: 100%;
  }
  .metal-text {
    top: 102px;
    left: 256px;
    @include betweenTableTablePro {
      transform: scale(0.8);
      top: 69px;
      left: 190px;
    }
    @include table {
      transform: scale(0.7);
      top: 52px;
      left: 157px;
    }
    @include phone {
      transform: scale(0.64);
      top: 39px;
      left: 136px;
    }
  }
  .templeName {
    height: 33px;
    width: 143px;
    .textContainer {
      width: 143px;
    }
  }
  .godName {
    width: 159px;
    height: 74px;
    .textContainer {
      width: 159px;
    }
  }
  .gift {
    margin-left: auto;
    width: 110px;
    height: 33px;
    .textContainer {
      width: 110px;
    }
  }
}
</style>
